import { React, useState, useEffect, useCallback, useRef } from "react";
import { GET_BASE_URL } from "../utils/Constants";
import { LazyLoadImage } from "react-lazy-load-image-component";
import downloadIcon from "../assets/res/download.svg"

function HorizontalLoading({ title, author, image, link, closeLoading }) {

    const isHandleExternalRef = useRef(false);
    const [progress, setProgress] = useState(0);
    const [downloadSpeed, setDownloadSpeed] = useState(0);
    const [isHandleExternal, setIsHandleExternal] = useState(false);

    useEffect(() => {
        // THIS IS THE MAGIC PART
        isHandleExternalRef.current = isHandleExternal;
    }, [isHandleExternal]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setProgress((prevWidth) => {
                // Generate a random increment (e.g., between 1 and 15)
                const randomIncrement = Math.floor(Math.random() * 3) + 1;
                const newWidth = prevWidth + randomIncrement;

                if (newWidth >= 100) {
                    // If the new width exceeds or reaches 100%, clear the interval
                    clearInterval(intervalId);
                    setDownloadSpeed(0);
                    if (!isHandleExternalRef.current) {
                        setTimeout(redirectToOtherPage, 2000);
                    }
                    return 100;
                }

                // 2. Update Download Speed (randomly)
                // Generate a random speed between, for example, 0.5 Mbps and 15.0 Mbps
                const randomSpeed = (Math.random() * 10 + 1).toFixed(2);
                setDownloadSpeed(randomSpeed);

                // Return the new, randomly incremented width
                return newWidth;
            });
        }, 1000); // Still updates every 1 second

        // Cleanup function
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    function redirectToOtherPage() {
        setIsHandleExternal(true);

        console.log(isHandleExternalRef.current);
        if (!isHandleExternalRef.current) {
            window.open(link, "_self");
        }

        closeLoading();
    }

    return (
        <div className=" flex flex-col p-[16px]">
            <div className="flex flex-row">

                <img
                    src={GET_BASE_URL() + "images/" + image}

                    className="w-[64px] h-[64px] rounded-lg "
                />


                <div className="flex flex-col ml-[12px] items-start">
                    <div className="  medium text-[20px]  text-dark">{title}</div>
                    <div className="medium text-[16p] text-dark">{author}</div>

                    <div className="flex flex-row items-center">

                        <div className="h-[12px] w-[12px] bg-primary rounded-full flex items-center justify-center">
                            <img
                                src={downloadIcon}
                                className="w-[10px] h-[10px] rounded-lg "
                            />


                        </div>

                        <div className=" text-[12px] medium text-primary ml-[4px]">Downloading...</div>
                        <div className=" text-[12px]  medium text-gray-600 ml-[4px]">{downloadSpeed} MB/s</div>
                    </div>


                </div>
            </div>

            <div className="w-full h-[22px]  bg-gray-200 rounded-[16px] mt-[16px]" >
                <div
                    style={{
                        width: `${progress}%`,
                        height: '100%',
                        backgroundColor: '#4CAF50',
                        borderRadius: '16px',
                        transition: 'width 0.5s ease-in-out',
                    }}
                ></div>
            </div>
            <div className=" medium text-gray-900 text-[14px] justify-end flex flex-row">
                {progress} % completed
            </div>
        </div>



    );

}

export default HorizontalLoading